"use client";

import { Link } from "@/i18n/routing";
import { ResetPassword, SendOtpForm, VerifyOtpForm } from "@repo/components";
import { PageTitle } from "@repo/components";
import { useForgotPassword } from "@repo/lib/hooks/account";
import { useTranslations } from "next-intl";
const ForgotPasswordWrapper = () => {
  const {
    showVerifyOTP,
    showResetPassword,
    token,
    otpValue,
    setOtpValue,
    formValues,
    formErrors,
    setFormErrors,
    handleValidation,
    isPending,
    handleVerifyOtp,
    setShowVerifyOTP
  } = useForgotPassword();
  const tCommon = useTranslations("Common");
  const tForgotPassword = useTranslations("ForgotPassword");
  return <>
      {!showVerifyOTP && !showResetPassword && <>
          <div className="mb-6 space-y-2 text-center">
            <PageTitle title={tForgotPassword("Forgot_Password")} variant="small" />
            <p>{tForgotPassword("Instructions")}</p>
          </div>
          <SendOtpForm formValues={formValues} formErrors={formErrors} setFormErrors={setFormErrors} handleValidation={handleValidation} setShowVerifyOTP={setShowVerifyOTP} />
        </>}
      {showVerifyOTP && <>
          <div className="mb-6 space-y-2 text-center">
            <PageTitle title={tCommon("Verification")} variant="medium" />
            <p>{tCommon("OTP_Heading")}</p>
          </div>
          <VerifyOtpForm handleSubmit={handleVerifyOtp} otpValue={otpValue} setOtpValue={setOtpValue} isPending={isPending} />
        </>}
      {showResetPassword && <ResetPassword title={tCommon("Set_Up_New_Password")} token={token} email={formValues?.email} />}

      <div className="border-lightgray mt-6 border-t">
        <Link href="/login" className="text-anchor-text hover:text-anchor-hover flex justify-center py-4 font-medium hover:underline" data-sentry-element="Link" data-sentry-source-file="ForgotPasswordWrapper.jsx">
          {tCommon("Back_To_Login")}
        </Link>
      </div>
    </>;
};
export default ForgotPasswordWrapper;